import classNames from 'classnames';
import type { FC } from 'react';
import './DiffLine.css';

export type DiffLineProps = {
  content: string;
  /** Showing changes inline = show 2 columns of lines */
  inline?: boolean;
  lineNumber?: number;
  /** Only in inline mode */
  newLineNumber?: number;
  status?: 'added' | 'removed' | 'unchanged';
};

const statusPrefixes = {
  added: '+',
  removed: '-',
  unchanged: '',
};

export const DiffLine: FC<DiffLineProps> = (props) => {
  const lineNumberCommonClasses = [
    'diff-line__number',
    props.status === 'added' && 'bg-green-300',
    props.status === 'removed' && 'bg-red-350',
  ];
  return (
    <div className='diff-line'>
      <div
        className={classNames(
          ...lineNumberCommonClasses,
          props.inline && 'diff-line__number--inline-first',
        )}
      >
        {props.lineNumber}
      </div>
      {props.inline && (
        <div className={classNames(lineNumberCommonClasses)}>
          {props.newLineNumber}
        </div>
      )}
      <div
        className={classNames(
          'diff-line__content',
          props.status === 'added' && 'bg-green-200',
          props.status === 'removed' && 'bg-red-300',
        )}
      >
        <div className='w-4 select-none'>
          {statusPrefixes[props.status ?? 'unchanged']}
        </div>
        <div className='flex-1'>{props.content}</div>
      </div>
    </div>
  );
};
